import { Box, Typography, Divider } from "@mui/material";
import EmailRecipientsCard from "./EmailRecipientsCard";
import AgentPreferenceApprovals from "./AgentPreferences/AgentPreferenceApprovals";
import useCredentialNotificationRecipients from "../../AgentManagement/components/CredentialVault/hooks/useCredentialNotificationRecipients";
import useNotificationRecipients from "./AgentPreferences/hooks/useNotificationRecipients";

const NotificationsCenter = () => {
	const { emails: credentialEmails, save: saveCredentialRecipients } = useCredentialNotificationRecipients();
	const { emails: preferenceEmails, save: savePreferenceRecipients } = useNotificationRecipients();

	const handleCredentialEmailsChange = (next) => {
		saveCredentialRecipients(next);
	};

	const handlePreferenceEmailsChange = (next) => {
		savePreferenceRecipients(next);
	};

	return (
		<Box>
			<Typography variant="h5" fontWeight={600} mb={0.5}>
				Notifications
			</Typography>
			<Typography variant="body2" color="text.secondary" mb={3}>
				Manage who gets notified about agent activity, and review pending preference approvals — all in one place.
			</Typography>

			<EmailRecipientsCard
				title="Credential Vault Update Notifications"
				description="Get notified by email whenever an agent updates any of their credentials — not just the password. You can assign more than one."
				emails={credentialEmails}
				onChange={handleCredentialEmailsChange}
			/>

			<EmailRecipientsCard
				title="Agent Preference Approval Notifications"
				description="Get notified by email whenever an agent submits a preference update for approval. You can assign more than one."
				emails={preferenceEmails}
				onChange={handlePreferenceEmailsChange}
			/>

			<Box my={4}>
				<Divider />
			</Box>

			<AgentPreferenceApprovals />
		</Box>
	);
};

export default NotificationsCenter;
